(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("bootstrapNiceSelect", [], factory);
	else if(typeof exports === 'object')
		exports["bootstrapNiceSelect"] = factory();
	else
		root["bootstrapNiceSelect"] = factory();
})(this, () => {
return 